import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

let initialPageViewSkipped = false; // module-level flag

export default function PixelRouteTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!initialPageViewSkipped) {
      initialPageViewSkipped = true;
      return; // first mount: snippet in index.html already fired
    }
    if (window.fbq) window.fbq('track', 'PageView');
    if (window.ttq?.page) window.ttq.page();
  }, [pathname, search]);

  return null;
}
